module.exports = __webpack_public_path__ + "media/images/prize__matchday@2x-6a90c7b0b3e6cb05d17063e6ca0c3d4a.jpg";